module.exports = __webpack_public_path__ + "img/icn_instagram_org.de6067eb.svg";